/* global d3 $ */
import dataService from '../../service/dataService.js'
import pipeService from '../../service/pipeService.js';
import {getSaliencyColor} from "../../vendor/color_helper";
import DrawSearchStats from "./drawSearchStats";

const lemmatizer = require('node-lemmatizer');
console.log("lemmatizer: ", lemmatizer.only_lemmas('leaves')[0]);

function isEmpty(obj) {
    return Object.keys(obj).length === 0;
}

// Compute if shap hits qc in questions. 
function shap_hit_qc(qc, stem, shap_positions) {
    let hit = false
    // console.log("Computing shap hit qc: ", qc, stem, shap_positions)
    // Delete multiple spaces and replace space with '_'
    stem = stem.replace(/\s{2,}/g, ' ')
    let all_qc_pos = [];
    let before_length = 0;
    stem = stem.replaceAll(' ', '').toLowerCase()
    qc = qc.replaceAll('_', '').toLowerCase()
    // console.log("STEM: ", stem, "qc", qc)
    while (stem.indexOf(qc) != -1) {
        var pos = stem.indexOf(qc) 
        all_qc_pos.push(pos + before_length)
        before_length += pos + qc.length
        if (pos + qc.length >= stem.length) {
            break
        }
        stem = stem.substring(pos + qc.length, stem.length)
    }
    if (all_qc_pos.length === 0) {
        // console.log("Shap hit: ", hit)
        return false;
    }
    // console.log(all_qc_pos)
    shap_positions.forEach((v, i) => {
        // console.log("pos", v[0], v[2])
        if (all_qc_pos.includes(v[2]) ) {
            hit = true;
        }
    })
    // console.log("Shap hit: ", hit)
    return hit
}

function generate_saliency(tokens, attributions, question_concept, stem) {
    let element_list = []
    let html = "";
    let qc_list = question_concept.split('_')
    qc_list.forEach((qc, index)=> {
        return qc_list[index] = qc.replaceAll(/[^\p{L}\p{N}\s]/gu, '').toLowerCase()
    })
    // console.log("Testing qc underline", qc_list)

    let all_qc_pos = [];
    let before_length = 0;
    stem = stem.replaceAll(' ', '_').toLowerCase()
    // console.log("STEM: ", stem)
    while (stem.indexOf(question_concept) != -1) {
        var pos = stem.indexOf(question_concept) 
        all_qc_pos.push(pos + before_length)
        before_length += pos + question_concept.length
        if (pos + question_concept.length >= stem.length) {
            break
        }
        stem = stem.substring(pos + question_concept.length, stem.length)
    }
    // console.log("Stem: ", stem, question_concept)
    console.log("Debugging underline qc: ", all_qc_pos)
    let curr_position = 0;
    for(let i = 0; i < tokens.length; i++){
        // console.log("current pos", curr_position, )
        // console.log("token", tokens[i], tokens[i].length)
        let token = tokens[i];
        let background_color = getSaliencyColor(attributions[i])
        let is_underline = false
        if (all_qc_pos.length > 0) {
            all_qc_pos.forEach((pos, index) => {
                if (curr_position >= pos && curr_position < pos + question_concept.length) {
                    is_underline = true
                    // console.log(curr_position, pos, question_concept.length)
                }
            })
        }
        let local_span_html = ""
        if (is_underline) {
            local_span_html = "<span style=\"background-color:" + background_color + "; text-decoration:underline" + "\">" + token + "</span>" + "&nbsp;"
        } else {
            local_span_html = "<span style=\"background-color:" + background_color + "\">" + token + "</span>" + "&nbsp;"
        }
        /*element_list.push((
            <span style={{"background":getSaliencyColor(attributions[i])}}>
                {tokens[i]}
            </span>
        ))*/
        html += local_span_html;
        curr_position += tokens[i].length + 1;
    }
    return html;
    //return element_list;
}

function process_color_html(question_stem, shap_results, question_concept) {
    // This is important since the space may contain multiple spaces and causing bugs. 
    question_stem = question_stem.replace(/\s{2,}/g, ' ')
    let tokens = question_stem.split(" ");
    let shap_mapping = {};
    shap_results.forEach((d) => {
        shap_mapping[d[2]] = d[1];
    })
    let curr_position = 0;
    let attribution = [];
    for(let i = 0; i < tokens.length; i++){
        if (shap_mapping.hasOwnProperty(curr_position)) {
            attribution.push(shap_mapping[curr_position]);
        } else {
            attribution.push(0);
        }
        curr_position += tokens[i].length;
    }
    let generated_html = generate_saliency(tokens, attribution, question_concept, question_stem);
    console.log("shap mapping", shap_results);
    return generated_html;
}

export default {
    name: 'InstanceView',
    components: {
    },
    props: {
        mainViewData: {},
        selectedDataset: '', 
        selectedSplit: '', 
        filterStopWords: false, 
    },
    computed: {
    },
    data() {
        return {
            search_input: '', 
            lassoedIndex: [], 
            lassoedData: {}, 
            searhButtonPushed: false, 
            matched_stems: [], 
            statsIndex: [],
            statsData: {},
            selected_data: {},
            selected_index: [],
            containerId: "instanceViewContainer",
            containerIdDict: {
                "accuracy": "accuracyBar", 
                "modelHit": "modelHitBar",
                "wordFreq": "wordFreqBarChart", 
            }, 
            currentPage: 1,
            totalPage: 100,
            gtEnabled: false,
            questionEditing: false,
            selected_question: {
                "question_concept": "qc",
                "question": "q",
                "question_html": "qt",
                "answer":{
                    "A": "a",
                    "B": "b",
                    "C": "c",
                    "D": "d",
                    "E": "e"
                },
                "ground_truth": "gt",
                "model_results": "model", 
                "relations": "relations", 
                "choices_one_hops": {
                    "A": [],
                    "B": [],
                    "C": [],
                    "D": [],
                    "E": [],
                }
            },
            edited_question: {
                "question": "q",
                // "question_html": "qt",
                "answer":{
                    "A": "a",
                    "B": "b",
                    "C": "c",
                    "D": "d",
                    "E": "e"
                },
                "model_results": "model", 
                // "relations": "relations", 
            },
            choiceBackground: {
                "A": "#AAAAAA", 
                "B": "#AAAAAA", 
                "C": "#AAAAAA", 
                "D": "#AAAAAA", 
                "E": "#AAAAAA", 
            },
            editChoiceBackground: {
                "A": "#AAAAAA", 
                "B": "#AAAAAA", 
                "C": "#AAAAAA", 
                "D": "#AAAAAA", 
                "E": "#AAAAAA", 
            },
            // user modes: explanation mode or edit mode
            usermode: "explanation",
        }
    },
    watch: {
        mainViewData: function(mainViewData){
            console.log("mainview data (changed) in Instance View: ", mainViewData);
            this.processMainViewData();
        },
        currentPage(newvalue){
            this.emitCurrentPage(newvalue);
        }, 
        filterStopWords(newValue) {
            this.updateSearhedStats();
        }

    },
    methods: {
        emitCurrentPage: function(newvalue){
            let local_currentPage = newvalue - 1;
            
            if(local_currentPage < this.selected_index.length && local_currentPage >= 0){
                let index = this.selected_index[local_currentPage];
                pipeService.emitCurrentInspected(index);
                //console.log("selected index", index);
            }
            
        },
        handleSearchPattern(search_input) {

            // Update selectedData?
            console.log("Initial search input: " + search_input)
            let raw_search_input = search_input;
            if (search_input.length === 0) {
                this.updateStatsData(this.lassoedIndex);
                this.updateSelected(this.lassoedIndex);
                return;
            }

            search_input = search_input.replace(/[^\p{L}\p{N}\s]/gu, '')
            console.log("Processed search input: " + search_input)
            
            let patternList = []
            // let stems = []
            let idList = []
            let seachInputs = search_input.split(' ')
            seachInputs.forEach((word, index) => {
                if (word.toUpperCase() === word) {
                    // All upper case means this word is a pattern
                    // https://stackoverflow.com/questions/58215855/how-to-get-full-list-of-pos-tag-and-dep-in-spacy
                    // https://spacy.io/usage/linguistic-features
                    const POS_LIST = ["ADJ", "ADP", "ADV", "AUX", "CONJ", "CCONJ", "DET", "INTJ", "NOUN", "NUM", "PART", "PRON", "PROPN", "PUNCT", "SCONJ", "SYM", "VERB", "X", "SPACE"]
                    if (POS_LIST.includes(word)) 
                        patternList.push({"POS": word})
                } else {
                    //////////////////////////////////////////
                    // patternList.push({"LOWER": word.toLowerCase()})
                    //////////////////////////////////////////
                    // use `lemma` to loose search constraints
                    patternList.push({"LEMMA": lemmatizer.only_lemmas(word.toLowerCase())[0]});
                }
            })
            var patternStr = JSON.stringify(patternList)

            this.lassoedIndex.forEach((index, i) => {
                idList.push(index.toString())
            })
            var idListStr = '[' + idList.join(',') + ']'
            // console.log("idList: ", idListStr)
            // console.log("stemList: ", stemList)
            
            // If search word or phrase or pattern depends on if all uppercase like NOUN, VERB, separated by space. 
            // let patternStr = '[{"LOWER": "hello"}, {"IS_ALPHA": True, "OP": "*"}, {"IS_PUNCT": True, "OP": "*"}, {"LOWER": "world"}]'
            // let stemList = '["Hello, xxx sdjakdakj world! Hello world!", "Lower hello: world"]'
            dataService.searchPattern(this.selectedDataset, this.selectedSplit, patternStr, idListStr, (matchedData) => {
                // console.log("Returned pattern matched:")
                // console.log(matchedData);
                let matchedIndex = []
                if (matchedData.length === 0) {
                    // this.currentPage = 1
                    this.selected_question = {
                        "question_concept": "...",
                        // "question": "Pattern not found in lassoed questions...",
                        "question_html": "Pattern not found in lassoed questions...",
                        "answer":{
                            "A": "...",
                            "B": "...",
                            "C": "...",
                            "D": "...",
                            "E": "..."
                        },
                        "ground_truth": "...",
                        "model_result": "...", 
                        "relations": "...", 
                    }
                    this.choiceBackground = {
                        "A": "white",
                        "B": "white",
                        "C": "white",
                        "D": "white",
                        "E": "white",
                    }
                } else {
                    let matchedStems = []
                    matchedData.forEach((m, i) => {
                        matchedStems.push(m.doc)
                    })
                    this.lassoedData.forEach((q, i) => {
                        if (matchedStems.includes(q.raw_question.question.stem)) {
                            matchedIndex.push(this.lassoedIndex[i])
                        }
                    })
                    // console.log("Pattern matched indexes: " + matchedIndex)
                    // searched_index = [this.selected_index[0], this.selected_index[1], this.selected_index[2]]
                }
                this.updateStatsData(matchedIndex)
                this.updateSelected(matchedIndex)
            })

            // acc_bars hover event
            let target_info = {"view": "instance_view", "target": "search"}
            let additional_info = {"search_content": raw_search_input};
            dataService.saveUserDataWrapper("click", target_info, additional_info);    
            
        }, 
        updateStatsData: function(statsIndex) {
            // Update lassoed index and data. 
            let refer_data = this.mainViewData;
            if(statsIndex.length == 0){
                this.statsIndex = []
                this.statsData = {}
                this.updateSearhedStats()
                return;
            }
            let updated_index = [];
            let statsData = [];
            for(let i = 0; i < statsIndex.length; i++){
                let index = statsIndex[i]
                if(refer_data.hasOwnProperty(index)){
                    statsData.push(refer_data[index]);
                    //selected_data[i] = refer_data[index];
                    updated_index.push(index);
                }
            }
            // console.log("statsData", statsData, statsIndex);
            this.statsIndex = statsIndex
            this.statsData = statsData;
            this.updateSearhedStats()
        }, 
        updateLassoedData: function(lassoedIndex) {
            // Update lassoed index and data. 
            let refer_data = this.mainViewData;
            if(lassoedIndex.length == 0){
                lassoedIndex = Object.keys(refer_data);
            }
            let updated_index = [];
            let lassoedData = [];
            for(let i = 0; i<lassoedIndex.length; i++){
                let index = lassoedIndex[i]
                if(refer_data.hasOwnProperty(index)){
                    lassoedData.push(refer_data[index]);
                    //selected_data[i] = refer_data[index];
                    updated_index.push(index);
                }
            }
            // console.log("lassoedData", lassoedData, lassoedIndex);
            this.lassoedIndex = lassoedIndex
            this.lassoedData = lassoedData;

            if (this.search_input.length === 0) {
                // If no search input, display all lassoed data
                this.updateStatsData(lassoedIndex)
                this.updateSelected(lassoedIndex)
            } else {
                this.handleSearchPattern(this.search_input)
            }
        }, 

        handleCurrentChange(val) {
            // Input: currentPage from event
            // Output: currentPage
            // Cascading methods: updateQuestion

            let local_currentPage = val;
            
            this.pageSize = this.selected_data.length;
            if (this.selected_data.length < local_currentPage) {
                local_currentPage = this.selected_data.length;
            }
            if (local_currentPage < 1) {
                local_currentPage = 1;
            }
            this.currentPage = local_currentPage;
            this.updateQuestion();


            // pagination select event
            let target_info = {"view": "instance_view", "target": "pagination"}
            let additional_info = {"currentPage": this.currentPage};
            dataService.saveUserDataWrapper("select", target_info, additional_info); 
        },
        processMainViewData: function() {
            // Input: mainViewData
            if(this.selected_index.length == 0 && this.search_input.length === 0){
                this.selected_index = Object.keys(this.mainViewData);
            }
            this.updateLassoedData(this.selected_index)
            this.processSelected();
            this.updatePagination();
            this.updateQuestion();
            this.drawSearchStats.layout(this.lassoedData);
        },
        updatePagination: function(){
            // According to selected_data
            // Update totalPage and currentPage
            let local_currentPage = this.currentPage;
            if (local_currentPage < 1) {
                local_currentPage = 1;
            }
            this.totalPage = this.selected_data.length;
            if(this.selected_data.length < local_currentPage){
                local_currentPage = this.selected_data.length;
            }
            this.currentPage = local_currentPage;
            // console.log("total page, current page", this.totalPage, this.currentPage);
            this.emitCurrentPage(local_currentPage);
        },
        updateSelected: function(selected_index){
            this.selected_index = selected_index;
            this.processSelected();
            this.updatePagination();
            this.updateQuestion();
        },
        processSelected: function(){
            // According to selected_index and mainViewData 
            // update selected_data and selected_index
            let selected_index = this.selected_index;
            let refer_data = this.mainViewData;
            // if(selected_index.length == 0){
            //     selected_index = Object.keys(refer_data);
            // }
            let updated_index = [];
            let selected_data = [];
            for(let i = 0; i < selected_index.length; i++){
                let index = selected_index[i]
                if(refer_data.hasOwnProperty(index)){
                    selected_data.push(refer_data[index]);
                    //selected_data[i] = refer_data[index];
                    updated_index.push(index);
                }
            }
            // console.log("selected_data", selected_data, selected_index);
            this.selected_data = selected_data;
            this.selected_index = updated_index;
        },  
        extractCurrentQuestion: function(){
            // Input: currentPage, mainViewData
            // Output: selected_question
            let index = this.currentPage - 1;
            let data = this.selected_data;
            // console.log("data", data)
            if (data.length <= 0){
                return;
            }
            if(index < 0){
                index = 0;
            }
            if(index >= data.length){
                index = data.length - 1;
            }
            let extracted_data = data[index];
            let answers = {}
            extracted_data.raw_question.question.choices.forEach((d)=>{
                answers[d["label"]] = d["text"];
            })
            let question_stem = extracted_data.raw_question.question.stem;
            let shap_results = extracted_data.shap_concept_positions;
            let question_html = process_color_html(question_stem, shap_results, extracted_data.question_concept)
            let relations = []
            for (const i in extracted_data.question_concept_correct_answer_relations) {
                let r = extracted_data.question_concept_correct_answer_relations[i]
                if (!relations.includes(r[0]))
                    relations.push(r[0])
            }
            let selected_question_local = {
                "question_concept": extracted_data.question_concept,
                "question": extracted_data.raw_question.question.stem,
                "question_html": question_html,
                "answer": answers,
                "ground_truth": extracted_data.ground_truth,
                "model_result": extracted_data.model_result, 
                "relations": relations.join(", "), 
            }
            return selected_question_local;
        },
        updateQuestion: function(){
            // Input: currentPage, mainViewData
            // Output: selected_question
            let index = this.currentPage - 1;
            let data = this.selected_data;
            // console.log("data", data)
            if (data.length <= 0){
                return;
            }
            if(index < 0){
                index = 0;
            }
            if(index >= data.length){
                index = data.length - 1;
            }
            let extracted_data = data[index];
            let answers = {}
            extracted_data.raw_question.question.choices.forEach((d)=>{
                answers[d["label"]] = d["text"];
            })
            let question_stem = extracted_data.raw_question.question.stem;
            let shap_results = extracted_data.shap_concept_positions;
            let question_html = process_color_html(question_stem, shap_results, extracted_data.question_concept)
            let relations = []
            for (const i in extracted_data.question_concept_correct_answer_relations) {
                let r = extracted_data.question_concept_correct_answer_relations[i]
                if (!relations.includes(r[0]))
                    relations.push(r[0])
            }
            let selected_question_local = {
                "question_concept": extracted_data.question_concept,
                "question": extracted_data.raw_question.question.stem,
                "question_html": question_html,
                "answer": answers,
                "ground_truth": extracted_data.ground_truth,
                "model_result": extracted_data.model_result, 
                "relations": relations.join(", "), 
            }
            this.selected_question = selected_question_local;
            this.edited_question = {
                "question": extracted_data.raw_question.question.stem,
                "answer": answers,
                "model_result": extracted_data.model_result, 
            }
            this.gtEnabled = true;
            // Update choices background colors:
            for (const [k, v] of Object.entries(answers)) {
                let correct_color =   "#93C47D" // "#fb8072"  // '#59CE8F'
                if (extracted_data.ground_truth === extracted_data.model_result) {
                    this.choiceBackground[k] = (v === extracted_data.ground_truth) ? correct_color : 'white'; 
                } else {
                    if (v === extracted_data.ground_truth) {
                        this.choiceBackground[k] = correct_color
                    } else if (v === extracted_data.model_result) {
                        this.choiceBackground[k] = "#EC5958" // "#E64C4C" // "#fb8072" // "#fbb4ae" // '#FF4A4A' // Wrong color
                    } else {
                        this.choiceBackground[k] = 'white'
                    }
                }
            }
            // Update edit tab choices backgrounds:
            for (const [k, v] of Object.entries(answers)) {
                let model_result_color = '#B1E1FF';
                this.editChoiceBackground[k] = (v === extracted_data.model_result) ? model_result_color : 'white'; 
            }
            let question_id = 0
            // Get one hop data of choices:
            if(index < this.selected_index.length && index >= 0){
               question_id = this.selected_index[index];
            }
            dataService.choicesOneHops(question_id, choicesOneHopDict => {
                selected_question_local['choices_one_hops'] = choicesOneHopDict
                this.selected_question['choices_one_hops'] = choicesOneHopDict
                console.log("Choices one hops: ", choicesOneHopDict)
            })

            d3.select('#choiceTooltip').remove()
            var hoverDiv = d3.select("body").append("div")
                .attr("class", "tooltip")
                .attr("id", "choiceTooltip")
                .style("opacity", 0)
            // Create tooltips:
            d3.selectAll(".choice-input")
                .data(['A', 'B', 'C', 'D', 'E'])
                .on('mouseover', function (d, i) {
                    let oneHops = []
                    let choice = selected_question_local['answer'][d].replaceAll(' ', '_')
                    if (selected_question_local.hasOwnProperty('choices_one_hops') && selected_question_local.choices_one_hops.hasOwnProperty(choice)) {
                        oneHops = selected_question_local.choices_one_hops[choice]
                    }
                    let uniqueLinks = []
                    for (const l of oneHops.map(l => {return [l[0], l[1]]})) {
                        if (!uniqueLinks.some(x => (x[0] === l[0] && x[1] === l[1]))) {
                            uniqueLinks.push(l)
                        }
                    }
                    if (uniqueLinks.length > 0) {
                        let oneHopsStr = '';
                        for (let i=0; i < uniqueLinks.length; i++) {
                            oneHopsStr += uniqueLinks[i][0].toString() + " " + uniqueLinks[i][1].toString() + "<br>"
                        }
                        hoverDiv.transition()
                            .duration('50')
                            .style("opacity", ".9");
                        hoverDiv.html("Related concepts: <br>" + oneHopsStr)
                            .style("left", (d3.event.pageX - 105) + "px")
                            .style("top", (d3.event.pageY - 75) + "px");
                    }
                })
                .on('mouseout', function (d, i) {
                    hoverDiv.transition()
                        .duration('50')
                        .style("opacity", 0);
                })

        }, 
        onSave: function(){
            let editedQuestion = {
                ...this.selected_question,
                "gtEnabled": this.gtEnabled
            }
            pipeService.emitSaveInstances(editedQuestion);
        },
        onChangeInput: function(){
            console.log("onchangeinput");
            this.questionEditing = true;
        },
        onQuestionChange: function() {
            this.gtEnabled = false;
            let updateEdit = () => {
                this.questionEditing = false;
            }
            let editedQuestion = this.edited_question
            let choices = []
            for (const c in editedQuestion.answer) {
                choices.push(editedQuestion.answer[c])
            }
            // console.log("Edited choices: ", choices)
            let editedStem = d3.select("#questionStem").text().toString()
            // console.log("Edited question: ", editedStem)
            dataService.runModelQA({
                "question": editedStem,
                "choices": choices,
            }, (result) => {
                for (const [k, v] of Object.entries(editedQuestion.answer)) {
                    let model_result_color = '#B1E1FF'
                    if (v === result) {
                        this.editChoiceBackground[k] = model_result_color;
                    } else {
                        this.editChoiceBackground[k] = 'white'
                    }
                }
                console.log("Model return result: ", result)
                var splitedStem = editedStem.split(/\s|&nbsp;/g).filter(s => s != '')
                // d3.select("#questionStem").selectAll('*').remove()
                // d3.select("#questionStem")
                //     .text('')
                //     .selectAll("span")
                //     .data(splitedStem)
                //     .enter()
                //     .append("span")
                //     .html(function(d) {
                //         return d + "&nbsp;";
                //     })
                // console.log("Splited stem: ", splitedStem)
                updateEdit();
            })


            // run_model click event
            let originalQuestion = this.extractCurrentQuestion();
            let target_info = {"view": "instance_view", "target": "run_model"}
            let additional_info = {"editedQuestion": editedQuestion, "originalQuestion": originalQuestion};
            dataService.saveUserDataWrapper("click", target_info, additional_info);
        },
        updateSearhedStats: function() {
            this.drawSearchStats.layout(this.statsData, this.filterStopWords)
        }, 
        updateOnlyTrueFalse: function(onlyTrueFalse) {
            // console.log(this.statsIndex)
            // console.log("Inside updateOnlyTrueFalse: ", onlyTrueFalse)
            if (this.statsIndex.length === 0) {
                return;
            }
            if (onlyTrueFalse === 'unselected') {
                this.selected_index = this.statsIndex;
                this.processSelected();
                this.updatePagination();
                this.updateQuestion();
                return;
            }
            let statsIndex = this.statsIndex;
            let refer_data = this.mainViewData;
            let selectTrueFalse = (onlyTrueFalse === 'only_true') ? true : false;
            let updated_index = [];
            for (let i = 0; i < statsIndex.length; i++) {
                let index = statsIndex[i]
                if (refer_data.hasOwnProperty(index)){ 
                    if (refer_data[index].is_correct === selectTrueFalse) {
                        updated_index.push(index);
                    } 
                }
            }
            this.selected_index = updated_index;
            this.processSelected();
            this.updatePagination();
            this.updateQuestion();
        }, 
        updateOnlyQcHit: function(onlyQcHit) {
            // console.log(this.statsIndex)
            // console.log("Inside updateOnlyQcHit: ", onlyQcHit)
            if (this.statsIndex.length === 0) {
                return;
            }
            if (onlyQcHit === 'unselected') {
                this.selected_index = this.statsIndex;
                this.processSelected();
                this.updatePagination();
                this.updateQuestion();
                return;
            }
            let statsIndex = this.statsIndex;
            let refer_data = this.mainViewData;
            let selectTrueFalse = (onlyQcHit === 'only_hit') ? true : false;
            let updated_index = [];
            for (let i = 0; i < statsIndex.length; i++) {
                let index = statsIndex[i]
                if (refer_data.hasOwnProperty(index)){ 
                    let q = refer_data[index]
                    let qc_hit = shap_hit_qc(q.question_concept, q.raw_question['question']['stem'], q.shap_concept_positions)
                    if (qc_hit === selectTrueFalse) {
                        updated_index.push(index);
                    } 
                }
            }
            this.selected_index = updated_index;
            this.processSelected();
            this.updatePagination();
            this.updateQuestion();
        }, 

    },
    mounted: function() {
        const _this = this;
        _this.drawSearchStats = new DrawSearchStats(_this.containerIdDict)

        if(!isEmpty(_this.mainViewData)){
            console.log("initialize with mainview data in Instance View: ", _this.mainViewData)

            _this.processMainViewData();
        }
        pipeService.onSelectSubsetData(data => {
            // Data come from the subset view, instead of main view.
            if(!isEmpty(_this.mainViewData)){
                let selected_keys = data.map((d) => "" + d.index);
                this.updateLassoedData(selected_keys);
            }
        })
        pipeService.onSelectOnlyTrueFalse(msg => {
            this.updateOnlyTrueFalse(msg)
        })
        pipeService.onSelectOnlyQcHit(msg => {
            console.log("Emitted selected only qc hit in instance view", msg);
            this.updateOnlyQcHit(msg)
        })
    },

}